module.exports = __webpack_public_path__ + "img/3left-47a9ee6b.png";